<script setup lang="ts">
import { Form } from '~/layers/forms/models'
interface Props {
  modelValue: string | null
}

const props = defineProps<Props>()

const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)

const { LocalConfigurationStore } = stores()
</script>

<template>
  <FormsGlobalContainer
    :identifier="Form.travel"
    :cols="LocalConfigurationStore?.coveragePlanConfig?.groups.length ?? 1"
  >
    <FormsGlobalTitle
      text="Tipo de cobertura"
      icon-class="icon-[ph--newspaper-bold]"
    />

    <template
      v-for="option in LocalConfigurationStore?.coveragePlanConfig?.groups"
      :key="option"
    >
      <PvButton
        :severity="model === option.code ? undefined : 'secondary'"
        outlined
        class="p-inputtext:enabled:focus flex items-center gap-2 text-[var(--p-form-field-color)] bg-[var(--p-form-field-background)]"
        style-as-input
        :style="
          model === option.code
            ? {
                'border-color': 'var(--p-inputtext-focus-border-color)',
                'box-shadow': 'var(--p-inputtext-focus-ring-shadow)',
                outline:
                  'var(--p-inputtext-focus-ring-width) var(--p-inputtext-focus-ring-style) var(--p-inputtext-focus-ring-color)',
                'outline-offset': 'var(--p-inputtext-focus-ring-offset)',
              }
            : {}
        "
        @click="
          () => {
            model = option.code ?? null
          }
        "
      >
        <div
          class="flex items-center justify-center"
          :class="{ 'aspect-square h-full flex items-center justify-center': option.description }"
        >
          <template v-if="option.iconUrl">
            <ImageComponent
              :src="option.iconUrl"
              :alt="option.name"
              class="rounded-md invert"
              :class="{
                'size-6': !option.description,
                'size-8': option.description,
              }"
            />
          </template>
          <template v-else>
            <span
              class="icon-[ph--newspaper-bold]"
              :class="{
                'text-4xl': !!option.description,
                'text-2xl': !option.description,
              }"
            />
          </template>
        </div>

        <div
          v-if="option.description"
          class="h-full w-[1px] bg-white opacity-50"
        />

        <div class="flex flex-col text-left gap-1">
          <div class="font-bold uppercase leading-none">
            {{ option.name }}
          </div>
          <div
            v-if="option.description"
            class="leading-none text-xs"
          >
            {{ option.description }}
          </div>
        </div>
      </PvButton>
    </template>
  </FormsGlobalContainer>
</template>
